import { render, staticRenderFns } from "./videoItem.vue?vue&type=template&id=82d165c4&scoped=true"
import script from "./videoItem.vue?vue&type=script&lang=js"
export * from "./videoItem.vue?vue&type=script&lang=js"
import style0 from "./videoItem.vue?vue&type=style&index=0&id=82d165c4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82d165c4",
  null
  
)

export default component.exports